var React = require('react');

function ArrowAltRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M24 192h200v128.14H24a24 24 0 0 1-24-24V216a24 24 0 0 1 24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M265 71.11L441 239a24.08 24.08 0 0 1 0 34L265 440.94c-15.1 15.11-41 4.4-41-17V88.11c0-21.42 25.75-32.11 41-17z","className":"fa-primary","key":2})]);
}

ArrowAltRight.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowAltRight;

ArrowAltRight.default = ArrowAltRight;
